import axiosInstance  from '../../../services/axiosInstance';
import axiosInstanceNoToken from "../../../services/axiosInstanceNoToken";


//Login Page
export const requestOtp = async (mobile) => {
    const response = await axiosInstance.post('/sign-up', { mobile });
    return response.data;
};

// Verify OTP Page
export const verifyOtp = async (mobile, otp) => {
    const response = await axiosInstance.post('/sign-in', { mobile, otp });
    return response.data;
};

// Update Profile
export const updateUserProfile = async (request) => {
    const response = await axiosInstance.post('/users/update-profile', request );
    return response.data;
};
export const getStates = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/locations/states', {params} );
    return response.data;
};
export const getCities = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/locations/cities', {params} );
    return response.data;
};
